import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import './bank_chat.css';

function ChatPage() {
  const { state } = useLocation();
  const [messages, setMessages] = useState(state?.messages || []);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const bottomRef = useRef(null);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const sendMessage = async () => {
    if (!input.trim() || isLoading) return;

    const updated = [...messages, { role: 'user', content: input }];
    setMessages(updated);
    setInput('');
    setIsLoading(true);

    try {
      const response = await axios.post('/api/bankagent/chat', {
        messages: input
      }, {
        withCredentials: true   // ✅ send cookie to maintain session
      });

      const assistantMsg = response.data.message;
      var parsedMessage = JSON.parse(assistantMsg);
      console.log('parsedMessage:', parsedMessage);

      setMessages([...updated, { role: 'assistant', content: parsedMessage.user_message }]);
    } catch (error) {
      setMessages([...updated, { role: 'assistant', content: '❌ Failed to get response from AI! Resend message again..' }]);
    }

    setIsLoading(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') sendMessage();
  };

  return (
    <div className="chat-container">
<div className="chat-header">🧠 AI Assistant</div>

      <div className="chat-body">
        {messages.map((msg, idx) => (
          <div key={idx} className={`chat-message ${msg.role}`}>
            <div className="bubble">
              {Array.isArray(msg.content) ? (
                <>
                  <div style={{ marginBottom: '10px', fontWeight: 'bold', color: '#fff' }}>
                    These are the invoice details from the file:
                  </div>
                  {msg.content.map((item, index) => (
                    <div key={index} className="chat-object-entry">
                      {Object.entries(item).map(([key, value]) => (
                        <div key={key}>
                          <strong>{key}:</strong> {String(value)}
                        </div>
                      ))}
                      <hr style={{ border: '0.5px solid #444', margin: '8px 0' }} />
                    </div>
                  ))}
                </>
              ) : typeof msg.content === 'object' && msg.content !== null ? (
                Object.entries(msg.content).map(([key, value]) => (
                  <div key={key}>
                    <strong>{key}:</strong> {String(value)}
                  </div>
                ))
              ) : (
                // If the content string contains an <a> tag, render as HTML:
                msg.content.includes('<a ') ? (
                  <span
                    dangerouslySetInnerHTML={{ __html: msg.content }}
                  />
                ) : (
                  // Otherwise, just render the plain text
                  msg.content
                )
              )}
            </div>
          </div>
        ))}

        {isLoading && (
          <div className="chat-message assistant">
            <div className="bubble loading">
              <span className="dot"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
          </div>
        )}

        <div ref={bottomRef}></div>
      </div>


      <div className="chat-input">
        <input
          placeholder="Type your message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isLoading}
        />
        <button onClick={sendMessage} disabled={isLoading}>Send</button>
      </div>
    </div>
  );
}

export default ChatPage;
